var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGpa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1057_15742",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H36V36H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1057_15742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5607 31.5113C25.3318 30.0847 24.001 27.653 24.001 25.0067V23.0889L28.237 21.3945L32.4729 23.0889V25.0067C32.4729 27.653 31.1422 30.0847 28.9131 31.5113L28.237 31.9441L27.5607 31.5113Z",
    fill: "#2B195B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54558 20.0461C3.96425 20.5158 2.62479 21.5473 1.75854 22.9092L7.05729 31.0613H12.7048L5.54558 20.0461Z",
    fill: "#2B195B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5872 17.2349V19.765C10.5872 20.9347 11.5354 21.883 12.7052 21.883C13.8749 21.883 14.8231 20.9347 14.8231 19.765V17.2349",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2351 0.703128C15.0654 0.703128 14.1171 1.65136 14.1171 2.82115C14.1171 1.65136 13.1688 0.703128 11.9991 0.703128H4.23315V4.2331C4.23315 5.40281 5.18139 6.35112 6.35118 6.35112H14.1171H18.3531V2.82115C18.3531 1.65136 17.4048 0.703128 16.2351 0.703128Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.728 17.647H12.6821C9.57551 17.647 7.05713 15.1286 7.05713 12.022V6.35108H18.353V12.022C18.353 15.1286 15.8347 17.647 12.728 17.647Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.293 12.705H14.1169",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.703125 31.0609H12.705C15.0445 31.0609 16.941 32.9574 16.941 35.2969H4.23309",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7051 31.0609V35.2969",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05713 31.0609V35.2969",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.825 26.4719L27.8839 27.5309L30.002 25.413",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7533 20.9464C20.6648 20.2012 19.3481 19.765 17.9293 19.765H14.823",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.587 19.765H7.48062C3.73753 19.765 0.703125 22.7994 0.703125 26.5426V35.2969H24.7069V32.8807",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4355 33.8898L28.2369 35.2969L26.0385 33.8898C23.0095 31.9513 21.177 28.6029 21.177 25.0067V21.177L28.2369 18.353L35.2969 21.177V25.0067C35.2969 28.6029 33.4645 31.9513 30.4355 33.8898Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpa);
export default __webpack_public_path__ + "static/media/gpa.b3dd820f035ad744ee6fdb3f6367a76d.svg";
export { ForwardRef as ReactComponent };